var summerEpisodeVideos = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    var videoBlock = document.getElementsByClassName('summer-episode__video-section');
    var videoClick = document.getElementsByClassName('summer-episode__video-link');

    if (videoBlock) {
      var ua = navigator.userAgent.toLowerCase(),
        isSafari = false,
        sandboxFlag = '';
      
      // Detect browser for allow presentation sandbox flag
      try {
        isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
      }
      catch(err) {}
      isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
      sandboxFlag = isSafari ? 'allow-scripts allow-same-origin' : 'allow-scripts allow-same-origin allow-presentation';

      for (var i = 0; i < videoClick.length; i++) {
        videoClick[i].addEventListener('click',videoList,false);
        videoClick[i].nextElementSibling.setAttribute('sandbox', sandboxFlag);
      }
      function videoList(){
        var episodeVideo = this.nextElementSibling;
        episodeVideo.src += "&autoplay=1";
        this.parentElement.classList.add("remove-image");
      }
    }
  };
  init();
})();